import { Component, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { Button } from 'primeng/button';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NotificationService } from '../../shared/service/notification.service';
import CommonUtils from '../../shared/utils/common.utils';
import { Livestock, Registration, RegistrationResponse } from '../models/registration';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent implements OnChanges {

  @Input() registration!: Registration;
  @Input() orgId: number = 0;
  @Input() paymentStatus: string | undefined;

  @Output() previousClick = new EventEmitter();
  @Output() paymentComplete = new EventEmitter<RegistrationResponse>();

  liveStocks: Livestock[] = [];
  liveStocksByDept = new Map<string, Livestock[]>();

  constructor(
    private readonly registrationService: RegistrationService,
    private readonly notificationService: NotificationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['registration']) {
      if (this.registration.liveStocks) {
        this.liveStocks = this.registration.liveStocks;

        this.liveStocks.forEach(ls => {
          var i = this.liveStocksByDept.get(ls.department);

          if (!i) {
            i = new Array<Livestock>;
          }

          i.push(ls);

          this.liveStocksByDept.set(ls.department, i);
        });
      }
    }
  }

  get selectedLivestocks() {
    return Array.from(this.liveStocksByDept.entries());
  }

  onPay(btn: Button): void {
    btn.loading = true;

    this.registrationService.getPaymentToken(this.registration.id ?? 0)
      .subscribe({
        next: (response) => {
          // create form
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = `${response.paymentUrl}/payment/payment`;

          // add token as hidden field
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'token';
          input.value = response.token;
          form.appendChild(input);

          btn.loading = false;

          document.body.appendChild(form); // append to body and submit
          form.submit();
          document.body.removeChild(form); // Clean up
        },
        error: e => {
          btn.loading = false;
          this.notificationService.error({ message: e?.error?.message });
        }
      });
  }

  onPreviousClick() {
    this.previousClick.emit();
  }

  async onPrintConfirmation() {
    try {
      const response = await this.registrationService.downloadConfirmation(this.orgId, this.registration.id);
      const blobUrl = URL.createObjectURL(response.file);

      // Open in a new tab
      window.open(blobUrl, '_blank');
    } catch (e: any) {
      this.notificationService.error(e);
    }
  }

  async onDownloadConfirmation() {
    try {
      const response = await this.registrationService.downloadConfirmation(this.orgId, this.registration.id);
      const link = document.createElement('a');
      link.href = globalThis.URL.createObjectURL(response.file);
      link.download = response.fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e: any) {
      this.notificationService.error(e);
    }
  }

  getSubClassName = CommonUtils.getSubClassName;

  @ViewChildren(OverlayPanel) overlayPanels!: QueryList<OverlayPanel>;

  showOverlayPanel(event: Event, index: number) {
    const overlayPanel = this.overlayPanels.toArray()[index];
    if (overlayPanel) {
      overlayPanel.toggle(event);
    }
  }

}
